import { useMutation } from "react-query";
import {
	uploadBusinessBulkLoader,
	uploadParentEstateBulkLoader,
	uploadEstateBulkLoader,
	uploadUsersBulkLoader,
	uploadBusinessCenterParentBulkLoader,
	uploadBusinessCenterBulkLoader,
	uploadBalancesBulkLoader,
} from "@/api/Implementation/initialLoad";

export function useBusinessBulkLoader() {
	return useMutation({
		mutationFn: async (formData) => await uploadBusinessBulkLoader(formData),
	});
}

export function useParentEstateBulkLoader() {
	return useMutation({
		mutationFn: async (formData) => await uploadParentEstateBulkLoader(formData),
	});
}

export function useEstateBulkLoader() {
	return useMutation({
		mutationFn: async (formData) => await uploadEstateBulkLoader(formData),
	});
}

export function useUsersBulkLoader() {
	return useMutation({
		mutationFn: async (formData) => await uploadUsersBulkLoader(formData),
	});
}

export function useBusinessCenterParentBulkLoader() {
	return useMutation({
		mutationFn: async (formData) => await uploadBusinessCenterParentBulkLoader(formData),
	});
}

export function useBusinessCenterBulkLoader() {
	return useMutation({
		mutationFn: async (formData) => await uploadBusinessCenterBulkLoader(formData),
	});
}

export function useBalancesBulkLoader() {
	return useMutation({
		mutationFn: async (formData) => await uploadBalancesBulkLoader(formData),
	});
}
